// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    comms_find_conversations: 'Buscando entre tus conversaciones',
    comms_read_conversation: 'Leyendo la conversación',
    comms_send_message: 'Enviando el mensaje',
  },
  ca: {
    comms_find_conversations: 'Cercant entre les teves converses',
    comms_read_conversation: 'Llegint la conversa',
    comms_send_message: 'Enviant el missatge',
  },
  en: {
    comms_find_conversations: 'Looking through your conversations',
    comms_read_conversation: 'Reading the conversation',
    comms_send_message: 'Sending the message',
  },
  fr: {
    comms_find_conversations: 'Recherche dans vos conversations',
    comms_read_conversation: 'Lecture de la conversation',
    comms_send_message: 'Envoi du message',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
